import { GuideTypeCode, SERVICE_CODE } from "./../../types/index";
import { Result, combine } from "neverthrow";
import { IHttpService } from "@/repositories/shared/httpService";
import { HttpError } from "@/repositories/shared/errors/httpError";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { inject, injectable } from "inversify";
import TYPES from "@/ioc/identifiers";
import { IGuideInfoData } from "@/domain/entities/guide";
import {
  IGuideInfoParser,
  HttpGuideInfoResponse,
  IGuideRepository,
} from "./guideRepository.types";

@injectable()
export class GuideRepository implements IGuideRepository {
  @inject(TYPES.IGuideInfoParser)
  private guideInfoParser!: IGuideInfoParser;

  private httpService: IHttpService;

  constructor(@inject(TYPES.IHttpService) httpService: IHttpService) {
    this.httpService = httpService;
    this.httpService.initService(
      `${
        process.env.VUE_APP_CDN_BASE_URL
      }/commute/pages/guide/${SERVICE_CODE.toLowerCase()}`
    );
  }

  async getGuideInfos(): Promise<
    Result<IGuideInfoData[], ParseError | HttpError>
  > {
    const parseTo = (response: HttpGuideInfoResponse) => {
      const guideInfo = response.data.map(this.guideInfoParser.toDomain);
      return combine(guideInfo);
    };
    return await this.httpService.get<HttpGuideInfoResponse, IGuideInfoData[]>(
      {
        url: `/${GuideTypeCode.GUIDE}.json`,
      },
      { parseTo }
    );
  }

  async getGuideInfosOnLogout(): Promise<
    Result<IGuideInfoData[], ParseError | HttpError>
  > {
    const parseTo = (response: HttpGuideInfoResponse) => {
      const guideInfo = response.data.map(this.guideInfoParser.toDomain);
      return combine(guideInfo);
    };
    return await this.httpService.get<HttpGuideInfoResponse, IGuideInfoData[]>(
      {
        url: `/${GuideTypeCode.GUIDE_LOGOUT}.json`,
      },
      { parseTo }
    );
  }

  async getOperationInfos(): Promise<
    Result<IGuideInfoData[], ParseError | HttpError>
  > {
    const parseTo = (response: HttpGuideInfoResponse) => {
      const guideInfo = response.data.map(this.guideInfoParser.toDomain);
      return combine(guideInfo);
    };
    return await this.httpService.get<HttpGuideInfoResponse, IGuideInfoData[]>(
      {
        url: `/${GuideTypeCode.OPERATION}.json`,
        config: {
          baseURL: `${
            process.env.VUE_APP_CDN_BASE_URL
          }/commute/pages/operation/${SERVICE_CODE.toLowerCase()}`,
        },
      },
      { parseTo }
    );
  }
}
